import * as types from '../constants/actionTypes';
import objectAssign from 'object-assign';
const initialState = {
	statistics: [],
};

export default function appointmentReducer(state = [], action) {
	switch (action.type) {
		case types.PATIENT_VS_APPOINTMENTS:
			return objectAssign({}, state, {
				statistics: action.statistics,
			});
		case types.TOTAL_TURNOVER_VS_REVENU:
			return objectAssign({}, state, {
				TurnOverCountrystatistics: action.TurnOverCountrystatistics,
	  });
	  case types.GET_REVENUE_BY_STATUS_COUNTRY:
			return objectAssign({}, state, {
				getRevenewByStatusCountry: action.getRevenewByStatusCountry,
      });
      case types.TOTAL_TURNOVER_F2F_ON_VS_REVENU:
			return objectAssign({}, state, {
				TurnOverF2FONCountrystatistics: action.TurnOverF2FONCountrystatistics,
			});
		case types.RATE_VS_PATIENT:
			return objectAssign({}, state, {
				rateStats: action.rateStats,
			});
		case types.APPOINTMENT_REVENUE:
			return objectAssign({}, state, {
				appRevStats: action.appRevStats,
			});
		case types.MEDFIX_REVENUE: {
			return objectAssign({}, state, {
				medfixRevStats: action.medfixRevStats,
			});
		}
		default:
			return state;
	}
}
